module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_j_melanistic.680d2965.png";